module.exports=require("./src/superagent-promise-plugin");